import { Card, Empty, type EmptyProperties } from 'ui';

type P = {
  emptyState?: EmptyProperties;
};

const defaultProps = {
  description: 'There are no posts to display here',
  title: 'No post',
};

const ContentObjectFeedEmptyState = ({ emptyState: { description, image } = defaultProps }: P) => (
  <Card>
    <Empty
      description={description}
      // TODO: ask design team which image should be default
      image={image}
    />
  </Card>
);

export default ContentObjectFeedEmptyState;
